<template>
  <div id="search-how-to-container">
    <BackComponent />

    <div id="search-how-to" v-html="$i18n.t('searchHowTo')"></div>
  </div>
</template>



<script>
import { loadLocaleMessages } from "../i18n.js";
import BackComponent from "./BackComponent.vue";
export default {
  name: "SearchHowTo",
  components: {
    BackComponent: BackComponent,
  },
  data() {
    return {
      dxaFull: process.env.VUE_APP_DXA_FULL,
    };
  },
  mounted() {
    loadLocaleMessages("en");
  },
};
</script>



<style scoped lang="scss">
#search-how-to-container {
  @include flex-center;
  flex-direction: column;
  background-color: white;
  width: 100%;
}

#back {
  @include flex-center;
  justify-content: flex-start;
  height: 50px;
  width: 100%;
  padding: 30px 50px 0 50px;
}
#back .fas {
  font-size: 75%;
  padding-right: 4px;
}
#back button {
  @include button-styles;
  padding: 2px;
  font-weight: bold;
}

#search-how-to {
  width: 50%;
  padding: 50px;
}
#search-how-to a {
  @include link-styles;
}
#search-how-to a:hover {
  @include link-hover-styles;
}

@media only screen and (max-width: 1199px) {
  #search-how-to {
    width: 70%;
  }
}

@media only screen and (max-width: 974px) {
  #search-how-to {
    width: 80%;
  }
}

@media only screen and (max-width: 849px) {
  #search-how-to {
    width: 88%;
  }
}

@media only screen and (max-width: 724px) {
  #search-how-to {
    width: 100%;
  }
}

@media only screen and (max-width: 599px) {
  #back {
    padding: 30px 30px 0 30px;
  }
  #search-how-to {
    padding: 30px;
  }
}
</style>